import { Link as RouterLink, useLocation } from 'react-router-dom';

import {
  Box,
  Grid,
  Breadcrumbs as MuiBreadcrumbs,
  Typography,
} from '@mui/material';

import { BREADCRUMBS_MAX_VISIBLE_PATH_SEGMENTS } from '@components/constants';
import { activeItem } from '@features/menu/menuSlice';
import { getBreadcrumbsTitle } from '@utils/breadcrumbs';

import { ROUTES } from '@constants';
import { useAppDispatch } from '@hooks';

const HOME_PATH = 'bonus-management';

export const Breadcrumbs = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const pathnames = location.pathname
    .split('/')
    .filter(Boolean)
    .slice(0, BREADCRUMBS_MAX_VISIBLE_PATH_SEGMENTS);

  if (pathnames.length === 0) {
    return null;
  }

  return (
    <Box>
      <Grid
        container
        sx={{
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
        }}
      >
        <Grid>
          <MuiBreadcrumbs aria-label="Breadcrumb" separator="/">
            <Typography
              component={RouterLink}
              onClick={() => dispatch(activeItem({ openItem: [HOME_PATH] }))}
              sx={{ textDecoration: 'none', color: 'text.secondary' }}
              to={ROUTES.BONUS_MANAGEMENT.ROOT}
              variant="h6"
            >
              Home
            </Typography>
            {pathnames.map((value, index) => {
              const last = index === pathnames.length - 1;
              const to = `/${pathnames.slice(0, index + 1).join('/')}`;
              const title = getBreadcrumbsTitle(value, pathnames);

              return last ? (
                <Typography
                  key={to}
                  sx={{ color: 'text.primary' }}
                  variant="subtitle1"
                >
                  {title}
                </Typography>
              ) : (
                <Typography
                  sx={{
                    color: 'inherit',
                    textDecoration: 'none',
                  }}
                  component={RouterLink}
                  key={to}
                  to={to}
                  variant="subtitle1"
                >
                  {title}
                </Typography>
              );
            })}
          </MuiBreadcrumbs>
        </Grid>
      </Grid>
    </Box>
  );
};
